export default __webpack_public_path__ + "static/media/logosvg.d5941c7a.svg";